import { AgencyProfile } from "~/types/Profile";

const agencyProfileDefault: AgencyProfile = {
  id: "",
  legalName: "",
  shortName: "",
  slug: "",
  isOffering: false,
  deliveryDistricts: [],
  deliveryOptions: {
    products: [],
    paymentTypes: [],
    deliveryTimes: [],
    defaultDeliveryDuration: {
      min: 0,
      max: 0,
    },
    deliveryVehicles: [],
    hoseLengths: [],
    packagings: [],
  },
  rating: {
    overall: {
      count: 0,
      average: 0,
    },
    lastYear: {
      count: 0,
      average: 0,
    },
  },
};

export default agencyProfileDefault;
